import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CallNowFab from "@/components/CallNowFab";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-[var(--brand-cream)]">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <CallNowFab />
    </div>
  );
}
